import React from 'react';
import { motion } from 'framer-motion';
import { statsData } from '../mockData';

const StatsSection = () => {
  return (
    <section className="py-24 bg-[#FAFAFA]" data-testid="stats-section">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statsData.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <h3 className="text-5xl md:text-6xl font-bold text-[#1A1A1A] mb-3 tracking-tight">
                {stat.value}
              </h3>
              <p className="text-gray-500 text-base">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
